// Store for the current auth getToken function - will be updated by the auth context
let currentGetTokenFn: (() => Promise<string | null>) | null = null;

// Function to set the current getToken function (called from components with access to Clerk hooks)
export const setGetTokenFunction = (
  getTokenFn: (() => Promise<string | null>) | null,
): void => {
  currentGetTokenFn = getTokenFn;
};

// Returns a fresh clerk session token
export const getToken = async (): Promise<string | null> => {
  // First try the stored getToken function from React context
  if (currentGetTokenFn) {
    try {
      return await currentGetTokenFn();
    } catch (error) {
      console.warn("Failed to get token from Clerk:", error);
    }
  }

  // Fallback to cookie-based extraction for backward compatibility
  try {
    const cookies = `; ${document.cookie}`;

    // Try multiple possible cookie names that Clerk might use
    const possibleCookieNames = [
      "__session",
      "__clerk_session",
      "_clerk_session",
      "session",
    ];

    for (const cookieName of possibleCookieNames) {
      const parts = cookies.split(`; ${cookieName}=`);
      if (parts.length > 1) {
        const token = parts.pop()?.split(";").shift();
        if (token?.trim() && token.startsWith("eyJ")) {
          return token;
        }
      }
    }
  } catch (error) {
    console.warn("Failed to extract token from cookies:", error);
  }

  return null;
};
